export default __webpack_public_path__ + "static/media/winter3.b713b92b.jpg";